"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReleasesMonthFilter = void 0;
const react_1 = __importStar(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const date_utils_1 = require("app/utils/date.utils");
const useOnClickOutside_1 = __importDefault(require("app/hooks/useOnClickOutside"));
const ReleasesMonthFilter = (props) => {
    var _a;
    if (!props.show)
        return null;
    const elementRef = react_1.default.useRef(null);
    const translatedMonths = props.language === 'en' ? date_utils_1.months.en : date_utils_1.months.fi;
    const api = (0, spa_core_1.useContentDeliveryAPI)();
    const currentYear = new Date().getFullYear();
    const [year, setYear] = (0, react_1.useState)(currentYear);
    const defaultResults = [];
    translatedMonths.forEach((item) => {
        defaultResults.push({ month: item, count: 0 });
    });
    let results = defaultResults;
    const [apiResults, setApiResults] = (0, react_1.useState)();
    const minYear = new Date().getFullYear() - 10;
    const handleYearChange = (prev) => {
        let newYear = prev ? year - 1 : year + 1;
        if (newYear < minYear)
            newYear = minYear;
        else if (newYear > currentYear)
            newYear = currentYear;
        setYear(newYear);
    };
    if (apiResults && ((_a = apiResults.results) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        apiResults.results.forEach((item) => {
            try {
                const time = new Date(item.startPublish).getMonth();
                results[time].count = results[time].count + 1;
            }
            catch (_a) {
                // ignore on purpose
            }
        });
    }
    const handleMonthSelect = (month) => {
        let monthString = '';
        if (month !== undefined)
            monthString = month + 1 < 10 ? monthString = `0${+month + 1}` : `${+month + 1}`;
        props.setYear(year.toString(), monthString);
    };
    (0, useOnClickOutside_1.default)(elementRef, () => props.close(false));
    (0, react_1.useEffect)(() => {
        let isCancelled = false;
        if (props.show) {
            const yearfilter = props.filter + ` and startPublish ge ${year}-01-01T00:00:00Z and startPublish le ${year + 1}-01-01T00:00:00Z`;
            api.basicSearch(props.query, yearfilter, 'startPublish desc').then(x => {
                if (isCancelled)
                    return;
                setApiResults(x);
            }).catch(e => console.error('An error occurred', e));
        }
        return () => {
            isCancelled = true;
        };
    }, [year]);
    return react_1.default.createElement("div", { className: 'month-filter p-7 p-sm-9', ref: elementRef },
        react_1.default.createElement("div", { className: 'row' },
            react_1.default.createElement("div", { className: 'col-12 d-flex justify-content-between align-items-center pb-7' },
                react_1.default.createElement("button", { className: 'prev d-flex', onClick: () => handleYearChange(true), disabled: year === minYear },
                    react_1.default.createElement("span", { className: 'icon-nav-caret' }),
                    react_1.default.createElement("span", { className: 'visually-hidden' },
                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labelSettings, field: 'prevText' }))),
                react_1.default.createElement("span", { className: 'text-18' }, year),
                react_1.default.createElement("button", { className: 'd-flex', onClick: () => handleYearChange(false), disabled: year === currentYear },
                    react_1.default.createElement("span", { className: 'icon-nav-caret' }),
                    react_1.default.createElement("span", { className: 'visually-hidden' },
                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labelSettings, field: 'nextText' }))))),
        react_1.default.createElement("div", { className: 'row' },
            react_1.default.createElement("ul", { className: 'col-12' },
                react_1.default.createElement("li", null,
                    react_1.default.createElement("button", { className: 'd-flex justify-content-between align-items-center w-100 px-1 py-2 semibold', onClick: () => handleMonthSelect() },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labelSettings, field: 'wholeYearText' })),
                        react_1.default.createElement("div", null, (apiResults === null || apiResults === void 0 ? void 0 : apiResults.totalMatching) || ''))),
                results.map((item, index) => (react_1.default.createElement("li", { key: `${index}-${item}` },
                    react_1.default.createElement("button", { className: 'd-flex justify-content-between align-items-center w-100 px-1 py-2', disabled: item.count === 0, onClick: () => handleMonthSelect(index) },
                        react_1.default.createElement("div", null, item.month),
                        react_1.default.createElement("div", null, item.count !== 0 && item.count))))))));
};
exports.ReleasesMonthFilter = ReleasesMonthFilter;
exports.default = exports.ReleasesMonthFilter;
